// extracted by mini-css-extract-plugin
export default {"container":"author-initials_container__2BKbl"};